// @flow

import { apiClients } from '@app/services/api/clients'
import { getApiClient } from '@app/utils/apiUtils'

import type { LoginRequestPayload, LoginResponse } from '@app/types/Login'

export const postLoginApi = (credentials: LoginRequestPayload): Promise<LoginResponse> => {
  const client = getApiClient(apiClients, 'global')
  const url = `1.0/login`
  return client.post(url, credentials)
}